import { useSearchParams, useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft, Home } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get("order_id");

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-5">
      <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-10 max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-5">
          <XCircle className="w-9 h-9 text-amber-600" />
        </div>
        <h1 className="font-heading text-2xl font-extrabold text-slate-900" data-testid="payment-cancel-title">Payment Cancelled</h1>
        <p className="text-slate-500 mt-2">No worries — your order wasn't charged. You can complete your booking anytime.</p>
        <button
          onClick={() => navigate(orderId ? `/book` : "/book")}
          className="brand-gradient btn-shine text-white font-semibold w-full py-3 rounded-full mt-6 flex items-center justify-center gap-2"
          data-testid="payment-cancel-retry-btn"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Booking
        </button>
        <button onClick={() => navigate("/")} className="text-slate-500 text-sm mt-3 flex items-center justify-center gap-1 w-full hover:text-blue-600">
          <Home className="w-4 h-4" /> Home
        </button>
      </div>
    </div>
  );
}
